import { createContext, useEffect, useRef } from "react";
import { useContext } from "react";
import { usePriceCalculation } from "../hooks/usePriceCalculation";
import { TextSectionsListContext } from "./TextSectionsListContext";

export const PriceCalculationContext = createContext(null);

export const PriceCalculationProvider = ({ children }) => {
    const { recalculateAllPrices } = usePriceCalculation();
    const textSections = useContext(TextSectionsListContext);

    // Każda zmiana liczby sekcji (dodanie, usunięcie, wczytanie zapisanej
    // konfiguracji) przelicza całość — identyczne litery liczone są przez
    // wszystkie linie naraz, więc cena nie jest sumą cen sekcji.
    const prevLengthRef = useRef(textSections.length);
    useEffect(() => {
        if (textSections.length !== prevLengthRef.current) {
            recalculateAllPrices();
        }
        prevLengthRef.current = textSections.length;
    }, [textSections.length, recalculateAllPrices]);

    return (
        <PriceCalculationContext.Provider value={{ recalculateAllPrices }}>
            {children}
        </PriceCalculationContext.Provider>
    );
};
